import { NodeViewRenderer, NodeViewRendererProps } from '@tiptap/core';
import { Node } from '@tiptap/pm/model';
import { Image } from '@tiptap/extension-image';

export const ResizableImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: 'auto',
        renderHTML: attributes => ({
          width: attributes['width'],
          style: `width: ${attributes['width']}; height: ${
            attributes['height'] || 'auto'
          }`,
        }),
      },
      height: {
        default: 'auto',
      },
      textAlign: {
        default: 'left',
        renderHTML: attributes => ({
          'data-text-align': attributes['textAlign'],
        }),
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    // 뷰어(innerHTML)에서 보일 때의 HTML 구조를 정의합니다.
    // 기존 Image의 renderHTML(img 태그만 생성)을 따르되, 추가한 속성들이 포함되게 합니다.
    return ['img', HTMLAttributes];
  },

  addNodeView(): NodeViewRenderer {
    return (props: NodeViewRendererProps) => {
      const { node, getPos, editor } = props;
      const container = document.createElement('span');
      container.classList.add('resizable-image-container');

      const img = document.createElement('img');
      img.src = node.attrs['src'];

      const updateStyles = (n: Node) => {
        const width = n.attrs['width'];
        const height = n.attrs['height'];
        const align = n.attrs['textAlign'];

        img.style.width = width;
        img.style.height = height;
        // 컨테이너도 이미지 크기에 맞게 조정
        container.style.width = width === 'auto' ? 'fit-content' : width;

        if (align) {
          container.setAttribute('data-text-align', align);
          img.setAttribute('data-text-align', align);
        } else {
          container.removeAttribute('data-text-align');
          img.removeAttribute('data-text-align');
        }
      };

      updateStyles(node);
      container.style.display = 'inline-block';

      const handle = document.createElement('div');
      handle.classList.add('resize-handle');

      container.appendChild(img);
      container.appendChild(handle);

      let startX: number, startWidth: number;

      handle.addEventListener('mousedown', e => {
        e.preventDefault();
        startX = e.clientX;
        startWidth = img.clientWidth;

        const onMouseMove = (e: MouseEvent) => {
          const currentWidth = startWidth + (e.clientX - startX);
          img.style.width = `${currentWidth}px`;
          container.style.width = `${currentWidth}px`;
        };

        const onMouseUp = () => {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);

          if (typeof getPos === 'function') {
            editor.commands.updateAttributes(this.name, {
              width: `${img.clientWidth}px`,
            });
          }
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      return {
        dom: container,
        contentDOM: null,
        update: updatedNode => {
          if (updatedNode.type.name !== this.name) return false;
          img.src = updatedNode.attrs['src'];
          updateStyles(updatedNode);
          return true;
        },
      };
    };
  },
});
